import { OverlayState } from "../../types";
import { typedAction } from "../helpers";
import { SET_OVERLAY_VISIBILITY } from "./actionTypes";

const initialState: OverlayState = { isVisible: false };

export const setOverlayVisibility = (isVisible: boolean) => {
    return typedAction(SET_OVERLAY_VISIBILITY, isVisible);
}

type OverlayAction = ReturnType<typeof setOverlayVisibility>;

export function overlayReducer(
    state = initialState,
    action: OverlayAction
): OverlayState {
    switch (action.type) {
        case SET_OVERLAY_VISIBILITY:
            return { isVisible: action.payload };
        default:
            return state;
    }
}